import axios from "axios";

jQuery(".menu-mobile").click(function () {
    jQuery(".menu-wrapper").toggleClass("act");
})
jQuery(".collapse-items .head").click(function () {
    if (!jQuery(this).hasClass("act")) {
        jQuery(".collapse-items .head").removeClass("act").next().slideUp();
        jQuery(this).next().slideToggle();
        jQuery(this).toggleClass("act");
    } else {
        jQuery(".collapse-items .head").removeClass("act").next().slideUp();
    }
})

jQuery("#produto").change(function () {
    jQuery("#contato").val(jQuery(this).val());
    jQuery(".contactForm").attr("id", jQuery(this).val());
    jQuery(".contactForm").attr("name", "Addsuite | " + jQuery(this).val());
})



jQuery(".menu-mobile").click(function () {
    jQuery(".menu-mobile-container").toggleClass("act");
});

if (jQuery(".contactForm").length > 0)
    document.querySelector('.contactForm').addEventListener('submit', function (event) {
        event.preventDefault(); // Impedir o envio do formulário padrão
        jQuery(".abs-loading").fadeIn();
        // Obter os valores dos campos do formulário
        const nome = document.getElementById('nome').value;
        const email = document.getElementById('email').value;
        const empresa = document.getElementById('empresa').value;
        const telefone = document.getElementById('telefone').value;
        const mensagem = document.getElementById('mensagem').value;
        const contato = jQuery("#contato").length > 0 ? document.getElementById('contato').value : "";
        const chleba_lead_id = document.getElementById("chleba_lead_id").value;

        // Criar o objeto de dados para enviar
        const data = {
            nome: nome,
            email: email,
            empresa: empresa,
            telefone: telefone,
            mensagem: mensagem,
            contato: contato,
            site_url: window.location.href
        };

        var image = document.createElement("img");

        // Enviar a solicitação POST para o endpoint
        axios.post(site_url.url + '/wp-json/wp/v2/postContato', data)
            .then(function (response) {
                jQuery(".abs-loading").fadeOut();
                image.src = "https://servico.addintelligence.com.br/contentserver/AddSuite.cli/CustRel.aspx?canal=Fale_Conosco&subcanal="+chleba_lead_id+"&servico="+contato+"&tiporel=60";
                document.body.append(image);
                alert('Formulário enviado com sucesso!');
                document.querySelector('.contactForm').reset();
            })
            .catch(function (error) {
                console.error(error);
                jQuery(".abs-loading").fadeOut();
                alert('Houve um erro ao enviar o formulário. Por favor, tente novamente.');
                document.querySelector('.contactForm').reset();
            });
    });


jQuery(document).ready(function () {
    jQuery('[name=chleba_lead_id]').val(guid());

    $('.hero-slider-title').slick({
        vertical: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
    })
})
